package com.macrofocus.eflux.ui.mui.themes

import mui.material.CssBaseline
import mui.system.ThemeProvider
import react.FC
import react.PropsWithChildren
import react.useState

val ThemeModule = FC<PropsWithChildren> { props ->
    val state = useState(Themes.LightDiviso)
    val (theme) = state

    ThemeContext(state) {
        ThemeProvider {
            this.theme = theme

            CssBaseline()
            +props.children
        }
    }
}